import { Controller } from "@hotwired/stimulus"

// Client-side filter for the contracts grid: clicking a plant-type chip shows
// only cards whose data-plant-type matches. The "All" chip (empty value) shows
// every card. Groups (the active grid + the closed-contracts section) hide when
// they have no visible card, so a stale header/summary doesn't linger.
// Wire-up:
//   data-controller="plant-filter"
//   <button data-plant-filter-target="chip" data-plant-type="Peas"
//           data-action="plant-filter#filter">
//   <div data-plant-filter-target="group"> … each card grid/section
//   <div data-plant-filter-target="card" data-plant-type="Peas"> … per card
export default class extends Controller {
  static targets = ["chip", "card", "group"]

  filter(event) {
    const type = event.currentTarget.dataset.plantType || ""

    this.chipTargets.forEach((chip) => {
      chip.classList.toggle("is-active", (chip.dataset.plantType || "") === type)
    })

    this.cardTargets.forEach((card) => {
      card.hidden = type !== "" && card.dataset.plantType !== type
    })

    this.groupTargets.forEach((group) => {
      const anyVisible = group.querySelectorAll("[data-plant-filter-target='card']:not([hidden])").length > 0
      group.hidden = !anyVisible
    })
  }
}
